import { VesselParticularsType } from "@/types/apiTypes";
import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const fetchVesselParticularsApi = async (
  vesselType: string,
): Promise<VesselParticularsType[]> => {
  const token = await getToken();
  if (!token) {
    throw new Error("Authorization token is required");
  }

  try {
    const response = await axios.get<VesselParticularsType[]>(
      `${API_BASE_URL}/vessels`,
      {
        params: { vessel_type: vesselType },
      },
    );
    return response.data || [];
  } catch (error) {
    console.error("Failed to fetch filtered vessels", error);
    return [];
  }
};
